<template>
  <div class="comment_box">
    <ProfileAvatarComponent
      class="small  c-pointer"
      :badges="false"
      :border="true"
      @click="goToProfile()"
      :key="profilePicture"
      :profileImage="profilePicture"
    />
    <div class="comment_container">
      <div class="commentimgdetailcontainer">
        <div class="commentnameimgdetail">
          <h6>{{ comment.fullName }}</h6>
          <div class="likeshareicon likeshareimgdetail leftExtraDv">
            <a v-if="showLikeIcon" href="javascript:;">
              <img
                class="emoicon01"
                src="../../../../../assets/images/likeicon01.png"
              />
            </a>
            <a v-if="showHeartIcon" href="javascript:;"
              ><img
                class="emoicon02"
                src="../../../../../assets/images/likeicon02.png"
            /></a>
            <a v-if="showAppreciatedIcon" href="javascript:;"
              ><img
                class="emoicon03"
                src="../../../../../assets/images/likeicon03.png"
            /></a>
            <a v-if="showKissIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/likeicon04.png"
            /></a>
            <a v-if="showAllGreenIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/allgreen.png"
            /></a>
            <a v-if="showAngryBullIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/angrybull.png"
            /></a>
            <a v-if="showDiamondHandIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/diamondhand.png"
            /></a>
            <a v-if="showDeadWeightIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/deadweight.png"
            /></a>
            <a v-if="showCryptoMarketIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/cryptomarket.png"
            /></a>
            <a v-if="showCrashingDownIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/crashingdown.png"
            /></a>
            <a v-if="showCrapmineIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/crapmine.png"
            /></a>
            <a v-if="showBloodBathIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/bloodbath.png"
            /></a>
            <a v-if="showDownChartIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/downchart.png"
            /></a>
            <a v-if="showFeelingSickIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/feelingsick.png"
            /></a>
            <a v-if="showGoldMineIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/goldmine.png"
            /></a>
            <a v-if="showKingOfTheMarketIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/kingofthemarket.png"
            /></a>
            <a v-if="showQueenOfTheMarketIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/queenofthemarket.png"
            /></a>
            <a v-if="showSadBullIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/sadbull.png"
            /></a>
            <a v-if="showShockIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/shock.png"
            /></a>
            <a v-if="showShockedIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/shocked.png"
            /></a>
            <a v-if="showSmirkingBullIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/smirkingbull.png"
            /></a>
            <a v-if="showToTheMoodIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/tothemood.png"
            /></a>
            <a v-if="showUpChartIcon" href="javascript:;"
              ><img
                class="emoicon04"
                src="../../../../../assets/images/reactions/upchart.png"
            /></a>
            <p>
              {{ countReactions.length > 0 ? countReactions.length : "" }}
            </p>
          </div>
        </div> 
        <p
          ref="textElement"
          @click.stop="onClickText"
          v-html="formattedComment"
          class="descriptive_text"
        ></p>
        <a
          v-if="isTruncated && visibleTextLength > truncatedLength"
          class="anchor_tag--more"
          @click.stop="checkTextLength(false)"
          >See More</a
        >
        <a
          v-else-if="visibleTextLength > truncatedLength"
          class="anchor_tag--more"
          @click.stop="checkTextLength(true)"
          >See Less</a
        >
        <PostMetaComponent
          :meta="comment.metaData"
          v-if="comment.metaData && comment.metaData.length"
        />
        <PostMediaComponent
          :media="comment.media"
          v-if="comment.media && comment.media.length"
        />
      </div>
      <div class="caption">
        <span class="like" v-if="isPostLiked">
          <i class="fas fa-thumbs-up active" @click.stop="unlikePost()"></i>
        </span>
        <button ref="likeIconFooterRef" type="button" v-else class="like clickable infoChangeButton">
          <i class="far fa-thumbs-up"></i>
          {{$t('common.actions.like')}}
          <div 
            v-if="!isPostLiked"
            ref="likeBoxRef" 
            class="likeBox comment-like-box popover_content" 
            :style="popoverStyle"
          >
            <figure
              v-for="reaction in reactions"
              :key="reaction"
              id="pf_like"
              @click.stop="likePost($event, reaction)"
            >
              <img
                :src="
                  require(`../../../../../assets/images/reactions/${reaction}.png`)
                "
              />
            </figure>
          </div>
        </button>

        <button
          type="button"
          class="like clickable infoChangeButton"
          v-if="comment?.userId === userId"
          @click="deleteComment(comment._id, allComments, isComment)"
        >
            {{$t('common.actions.delete')}}
          <div v-if="showDeleteLoading" class="loader"></div>
        </button>
        <button
          type="button"
          v-if="!isReplyItem"
          @click="showReply = !showReply"
          class="clickable infoChangeButton"
        >
          {{$t('common.actions.reply')}}
        </button>
        <p class="addClassDV">{{ momentTime }}</p>
      </div>
      <div class="reply_container" v-if="!isReplyItem">
        <template v-if="comment.replies">
          <template v-for="(reply, index) of comment.replies" :key="reply._id">
            <CommentItemComponent
              :sourceId="sourceId"
              :sourceType="sourceType"
              :postId="postId"
              :comment="reply"
              :is-comment="false"
              :all-comments="comment.replies"
              v-if="showAllReplies || index == 1"
            />
          </template>
          <a
            class="outlineAnchor"
            @click="showAllReplies = true"
            v-if="comment.replies.length > 1 && !showAllReplies"
            >View More Replies</a
          >
        </template>
        <CommentTextfieldComponent
          v-if="showReply"
          :sourceId="comment._id"
          :isComment="false"
          :postId="comment.sourceId"
          :userComment="comment"
          @handleReplyInput="showReply = false"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import CommentTextfieldComponent from "./CommentTextfieldComponent.vue";
import utilService from "@/services/util.service";
import { usePostFooter } from "../../composables/postfooter.composable";
import { usePostReaction } from "../../composables/postReaction.composable";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import {
  defineComponent,
  onMounted,
  ref,
  watchEffect,
  provide,
  computed,
  Ref,
  watch,
  onUnmounted,
} from "vue";
import PostMetaComponent from "./PostMetaComponent.vue";
import PostMediaComponent from "./PostMediaComponent.vue";
import storageService from "@/services/storage.service";
TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");
import ProfileAvatarComponent from "@/components/ProfileAvatarComponent.vue";
import router from "@/router/router";
import { RouteEnum } from "@/router/routeNames";
import { popModal } from "jenesius-vue-modal";
import { usePosts } from "../../composables/posts.composables";
import { useComment } from "../../composables/comments.composable";
import linkifyHtml from 'linkifyjs/html';

export default defineComponent({
  props: [
    "comment",
    "sourceId",
    "sourceType",
    "postId",
    "allComments",
    "isComment",
  ],
  components: {
    CommentTextfieldComponent,
    PostMetaComponent,
    ProfileAvatarComponent,
    PostMediaComponent,
  },
  setup(props, context) {
    const isTruncated = ref<boolean>(false);
    const textElement = ref<any>();
    const momentTime = ref<string>("");
    const sourceId = ref(props.sourceId);
    const postId = ref(props.postId);
    const userId = storageService?.getUser()?._id;
    const { intialData, likePost, unlikePost } = usePostFooter();
    const { handlePostreactions, postReactions } = usePostReaction();
    const { deleteComment, showDeleteLoading, toggleReply } = useComment();
    const { fromPopup } = usePosts();
    const comment = ref(props.comment);
    const profilePicture = ref<String>();
    const showAllReplies = ref<boolean>();
    const storageUser = storageService.user;
    const showReply = ref<boolean>(false);
    const isReplyItem = ref<Boolean>(
      comment.value.sourceType !== "post" &&
        comment.value.sourceType !== "papers"
    );
    watch(showReply, (newVal) => {
      toggleReply.value = newVal;
    })
    const sourceType = ref(isReplyItem.value ? "reply" : "comment");
    const getImageUrl = (url: string, directory: string | null) =>
      utilService.getImageUrl(url, directory);

    provide("userProfilePic", profilePicture);

    const isPostLiked = computed(() => {
      let filterePostReactions = postReactions.value.filter(
        (x) =>
          x.userId === storageUser.value!._id &&
          x.sourceId === props.sourceId &&
          x.sourceType === sourceType.value
      );
      return filterePostReactions.length > 0 ? true : false;
    });

    const showLikeIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "like" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showHeartIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "heart" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showAppreciatedIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "appreciated" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showKissIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "kiss" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const countReactions = computed(() => {
      var count = postReactions.value.filter(
        (item: any) =>
          item.sourceType === sourceType.value &&
          item.sourceId === sourceId.value
      );
      return count;
    });

    const updateMomentTime = () => {
      momentTime.value = timeAgo.format(
        new Date(parseInt(comment.value._id)),
        "mini-now"
      ) as string;
    };

    const truncatedLength = 96;

    const checkTextLength = (toTruncate = true) => {
      isTruncated.value = toTruncate;
      clampText(textElement.value, isTruncated, toTruncate);
    };

    const clampText = (
      textElem: HTMLElement,
      field: Ref<boolean>,
      value: boolean,
      defaultLengthCheck = truncatedLength
    ) => {
      if (!textElem) return;

      const body = comment.value.body || "";
      const linkifyOptions = {
        className: "anchor_tag",
        target: "_blank",
        rel: "noopener",
        defaultProtocol: "https",
      };

      // Create temp element to get visible text only
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = body;
      const visibleText = tempDiv.innerText;

      if (visibleText.length <= defaultLengthCheck) {
        textElem.innerHTML = linkifyHtml(body, linkifyOptions);
        field.value = false;
      } else if (value) {
        const truncatedText = visibleText.slice(0, defaultLengthCheck) + "...";
        textElem.innerHTML = linkifyHtml(truncatedText, linkifyOptions);
        field.value = true;
      } else {
        textElem.innerHTML = linkifyHtml(body, linkifyOptions);
        field.value = false;
      }
    };
    
    const visibleTextLength = computed(() => {
      const div = document.createElement("div");
      div.innerHTML = comment.value.body || "";
      return div.innerText.length;
    });


    onMounted(() => {
      profilePicture.value = utilService.getUserProfilePicture(
        comment.value.userId,
        comment.value.userProfilePicture,
        "male"
      );
      handlePostreactions(props.postId);
      intialData(sourceId.value, sourceType.value, postId.value);
      checkTextLength();
      if (props.postId) {
        updateMomentTime();
        setInterval(() => {
          updateMomentTime();
        }, 60 * 1000);
      }
    });

    watchEffect(() => {
      if (comment.value.replies && showAllReplies != null) {
        showAllReplies.value = comment.value.replies.length < 2;
      }
    });

    const goToProfile = () => {
      router.push({
        name: RouteEnum.profile,
        params: { username: props.comment.userName },
      });
      // fromPopup.value = true;
    };

    const showAllGreenIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "allgreen" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showAngryBullIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "angrybull" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showBloodBathIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "bloodbath" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showCrapmineIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "crapmine" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showCrashingDownIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "crashingdown" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showCryptoMarketIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "cryptomarket" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showDeadWeightIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "deadweight" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showDiamondHandIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "diamondhand" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showDownChartIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "downchart" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showFeelingSickIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "feelingsick" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showGoldMineIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "goldmine" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showKingOfTheMarketIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "kingofthemarket" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showQueenOfTheMarketIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "queenofthemarket" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showSadBullIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "sadbull" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showShockIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "shock" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showShockedIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "shocked" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showSmirkingBullIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "smirkingbull" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showToTheMoodIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "tothemood" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });

    const showUpChartIcon = computed(() => {
      if (postReactions.value && postReactions.value.length) {
        return (
          postReactions.value.filter(
            (x) =>
              x.reactionType === "upchart" &&
              x.sourceId === sourceId.value &&
              x.sourceType === sourceType.value
          ).length > 0
        );
      }
      return false;
    });
    const onClickText = (event) => {
      const selection = window.getSelection();
      const selectedText = selection ? selection.toString() : '';
      if (!selectedText) {
        checkTextLength();
      }
    }
    const reactions = ref([
      "like",
      "heart",
      "appreciated",
      "kiss",
      "allgreen",
      "angrybull",
      "bloodbath",
      "crapmine",
      "crashingdown",
      "cryptomarket",
      "deadweight",
      "diamondhand",
      "downchart",
      "feelingsick",
      "goldmine",
      "kingofthemarket",
      "queenofthemarket",
      "sadbull",
      "shock",
      "shocked",
      "smirkingbull",
      "tothemood",
      "upchart",
    ]);

    const formattedComment = computed(() => {
      if (!comment.value.body) return "";

      const link = linkifyHtml(comment.value.body, {
        className: "anchor_tag",
        target: "_blank",
        rel: "noopener",
        defaultProtocol: "https",
      });
      console.log("link", link);
      
      return link
    });

    const likeIconFooterRef = ref<HTMLElement | null>(null);
    const likeBoxRef = ref<HTMLElement | null>(null);
    const scrollOffset = ref(0); // trigger recompute

    onMounted(() => {
      const list = likeIconFooterRef.value?.closest(".list");

      const update = () => {
        scrollOffset.value = Date.now(); // just a trigger
      };

      window.addEventListener("resize", update);
      list?.addEventListener("scroll", update);

      onUnmounted(() => {
        window.removeEventListener("resize", update);
        list?.removeEventListener("scroll", update);
      });
    });

    const popoverStyle = computed(() => {
      if (likeIconFooterRef.value && likeBoxRef.value) {
        // depends on scrollOffset so recomputes
        scrollOffset.value; 

        const buttonRect = likeIconFooterRef.value.getBoundingClientRect();
        return {
          position: "fixed" as const,
          left: `${buttonRect.left}px`,
          top: `${buttonRect.top - likeBoxRef.value.offsetHeight - 8}px`,
          opacity: `1 !important`
        };
      }
      return {};
    });

    return {
      truncatedLength,
      showShockedIcon,
      showSmirkingBullIcon,
      showToTheMoodIcon,
      showUpChartIcon,
      showDownChartIcon,
      showFeelingSickIcon,
      showGoldMineIcon,
      showKingOfTheMarketIcon,
      showQueenOfTheMarketIcon,
      showSadBullIcon,
      showShockIcon,
      showDiamondHandIcon,
      showDeadWeightIcon,
      showCryptoMarketIcon,
      showCrashingDownIcon,
      showCrapmineIcon,
      showBloodBathIcon,
      showAngryBullIcon,
      showAllGreenIcon,
      reactions,
      goToProfile,
      isTruncated,
      showAllReplies,
      showReply,
      isReplyItem,
      comment,
      getImageUrl,
      profilePicture,
      likePost,
      intialData,
      sourceType,
      sourceId,
      postId,
      unlikePost,
      postReactions,
      countReactions,
      showLikeIcon,
      showHeartIcon,
      showAppreciatedIcon,
      showKissIcon,
      momentTime,
      isPostLiked,
      checkTextLength,
      textElement,
      userId,
      deleteComment,
      showDeleteLoading,
      formattedComment,
      visibleTextLength,
      onClickText,
      popoverStyle,
      likeIconFooterRef,
      likeBoxRef
    };
  },
});
</script>
<style lang="scss">
.mr-10 {
  margin-inline-end: 10px;
}
.comment_box {
  display: flex;
  align-items: flex-start;
  text-align: left;
  margin-bottom: 20px;

  .likeBox {
    // transition: none !important;
    opacity: 0 !important;
  }
  .profile_avatar {
    height: 40px;
    flex: 0 0 40px;
    margin-inline-end: 15px;
  }

  &:last-child {
    margin-bottom: 0;
  }

  .comment_container {
    flex-grow: 1;
    max-width: unset;
    max-height: unset;
    overflow: visible;
    width: 100%;

    .list {
      max-height: unset;
      overflow: visible;
    }

    h6 {
      font-size: 16px;
      font-weight: 500;
      color: var( --base-text-white);
      margin: 0;
    }

    p {
      font-size: 13px;
      font-weight: 400;
      color: var(--base-text-white);
      // opacity: 0.5;
      line-height: 21px;
      margin-bottom: 10px;
      word-break: break-word;

      a {
        color: var(--anchor-tag);
        font-size: var(--font-md);
        font-weight: 400;
        text-decoration: underline;
        opacity: 0.5;
      }
    }

    .media_card {
      margin-top: 20px;
    }

    figure {
      margin: 0;
    }

    .caption {
      display: flex;
      align-items: center;

      span {
        font-size: var(--font-md);
        font-weight: 400;
        display: inline-block;
        color: #ffffffb3;
      }

      button {
        color: #fb267b;
        font-weight: 500;
        font-size: var(--font-md);
        background: none;
        outline: none;
        border: none;
        margin-inline-start: 10px;
      }
    }
  }
}

.infoChangeButton {
  display: flex;
  align-items: center;
}
.addClassDV {
  margin-top: 5px;
}

.post_detail
  .detail_container
  > .rightAlign
  .comment_container
  .commentimgdetailcontainer
  .commentnameimgdetail
  .leftExtraDv
  p {
  margin-inline-start: 5px !important;
  margin-top: -5px !important;
}

.post_detail
  .detail_container
  > .rightAlign
  .comment_container
  .commentimgdetailcontainer
  .commentnameimgdetail
  .leftExtraDv
  a
  img {
  height: 20px !important;
  flex: 20px !important;
  max-width: 20px !important;
}
</style>
